import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-loader',
  templateUrl: './card-loader.component.html',
  styleUrls: ['./card-loader.component.scss']
})
export class CardLoaderComponent implements OnInit {
  @Input() count = 10;
  @Input() perLine = 3;

  Arr = Array;

  constructor() { }

  ngOnInit(): void {
  }

}
